import Api from '@/utils/api'
import BasicConfig from '@/config/basic'

// 获取月子中心用户列表（按角色查询）
export function getMaternityCenterUserList(query = {}) {
  return Api.get(`${BasicConfig.jDomain}/system/agents/options/get_by_role`, { params: query })
}